import { createAction } from 'redux-actions';
import { BackgroundInfo } from '@wix/da-shared-react/pkg/Background/types';
import { VisibilitySetting } from '../../modals/WriterPopup/types';
import { EditorState } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import { actionKey } from '../constants';

export interface SubmitStatusPayload {
  statusId?: number;
  editorRawState: EditorState;
  backgroundProps?: Partial<BackgroundInfo>;
  refreshAfterSubmit?: boolean;
  visibility?: VisibilitySetting;
}
export const submitStatus = createAction(
  `${actionKey}.STATUS_SUBMIT`,
  (payload: SubmitStatusPayload) => payload
);

export interface SubmitStatusFailurePayload {
  error: string;
}
export const submitStatusFailure = createAction(
  `${actionKey}.STATUS_SUBMIT_FAILURE`,
  (payload: SubmitStatusFailurePayload) => payload
);

export const submitStatusFailureDismiss = createAction(
  `${actionKey}.STATUS_SUBMIT_FAILURE_DISMISS`,
  () => ({})
);

export interface StatusPayload {
  statusId: number;
}
export interface SubmitStatusSuccessPayload extends StatusPayload {}
export const submitStatusSuccess = createAction(
  `${actionKey}.STATUS_SUBMIT_SUCCESS`,
  (payload: SubmitStatusSuccessPayload) => payload
);

export interface DeleteStatusPayload extends StatusPayload {}
export const deleteStatus = createAction(
  `${actionKey}.STATUS_DELETE`,
  (payload: DeleteStatusPayload) => payload
);
